import {
  ALL_COMMERCIAL_DATA,
  ALL_DEALS_DATA,
  ALL_EVENTS_DATA,
  ALL_NEAR_COMMERCIAL,
  ALL_PLACES_DATA,
  ALL_POPULAR_COMMERCIAL,
  ALL_USER_COMMERCIAL_DATA,
  COMMERCIAL_DETAILS,
  LANGUAGE,
  LOGIN,
  PLACE_DETAILS,
  USER, PLACE_STATES, SAVED_ITEMS
} from "../types";

export const userLogin = (payload) => {
  return {
    type: LOGIN,
    payload: payload,
  };
};

export const setUser = (payload) => {
  return {
    type: USER,
    payload: payload,
  };
};
export const setPlaceDetails = (payload) => {
  return {
    type: PLACE_DETAILS,
    payload: payload,
  };
};
export const setStatsOfPlaces = (payload) => {
  return {
    type: PLACE_STATES,
    payload: payload,
  };
};
export const setCommercialDetails = (payload) => {
  return {
    type: COMMERCIAL_DETAILS,
    payload: payload,
  };
};

export const setAllPlacesData = (payload) => {
  return {
    type: ALL_PLACES_DATA,
    payload: payload,
  };
};

export const setAllDealsData = (payload) => {
  return {
    type: ALL_DEALS_DATA,
    payload: payload,
  };
};

export const setAllEventsData = (payload) => {

  return {
    type: ALL_EVENTS_DATA,
    payload: payload,
  };
};

export const setAllCommercialData = (payload) => {
  return {
    type: ALL_COMMERCIAL_DATA,
    payload: payload,
  };
};

export const setAllUserCommercialData = (payload) => {
  console.warn("Setting all commercials data",payload);
  return {
    type: ALL_USER_COMMERCIAL_DATA,
    payload: payload,
  };
};

export const setAllPopularCommercialData = (payload) => {
  return {
    type: ALL_POPULAR_COMMERCIAL,
    payload: payload,
  };
};

export const setAllNearCommercialData = (payload) => {
  return {
    type: ALL_NEAR_COMMERCIAL,
    payload: payload,
  };
};
export const setLanguage = (payload) => {
  return {
    type: LANGUAGE,
    payload: payload,
  };
};
export const setAllSavedItems=(payload)=>{
  return {type:SAVED_ITEMS,payload:payload}
}
